export const PROJECT_REPORTS_CONFIG = {
    name            : 'Reports',
    menuName        : 'Reports',
    icon            : 'i5-chart-bar',
    image           : 'table',
    iconSvg         : 'isvg-reports',
    url             : 'reports',
    stringId        : 'projects-reports',
    appName         : 'reports',
    description     : 'Allows creating and viewing project-related reports with easy access to saved reports.',
    isSingleton     : true,
}
